import { Routes } from '@angular/router';
import { DashboardComponent } from './home/dashboard/dashboard.component';
import { LayoutComponent } from './components/layout/layout.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { AuthGuard } from './core/auth/auth.guard';
import {SlackOauthComponent} from './core/services/slack-oath/slack-oauth.component';

export const routes: Routes = [
  { path: 'login', component: LoginPageComponent },
  { path: 'slack/redirect', component: SlackOauthComponent },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],

    data: {
      breadcrumb: '',
      sidebar: {
        items: [
          {
            label: 'Dashboard',
            link: '/dashboard',
            icon: 'pi pi-home mr-2',
          },
          {
            label: 'Projects',
            link: '/projects',
            icon: 'pi pi-list mr-2',
          },{
            label: 'Settings',
            link: '/settings',
            icon: 'pi pi-cog mr-2',
          }
        ],
      },
    },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
        data: { breadcrumb: 'Dashboard' },
      },
      {
        path: 'dashboard',
        title: 'Project dashboard',
        component: DashboardComponent,
        data: { breadcrumb: 'Dashboard' },
      },
      {
        path: 'projects',
        title: 'Projects',
        loadChildren: () =>
          import('./projects/projects.routes').then(
            (m) => m.PROJECT_ROUTES
          ),
      },
      {
        path: 'settings',
        title: 'Settings',
        loadChildren: () =>
          import('./settings/settings/settings.routes').then(
            (m) => m.SETTINGS_ROUTES
          ),
      }
    ],
  },
  { path: '**', redirectTo: '' },
];
